﻿import { ParameterSchemaStation } from "../../API/Schema/ParameterSchema";
import { ILiveDataListenerContext, ILiveDataListener } from "../../ILiveDataListener";
import { MainSite } from "../../MainSite";
import { WarningGroup } from "../../Model/WarningGroup";
import { ISiteObservationsPage } from "./ISiteObservationsPage";

export class RIGS_Heading implements ISiteObservationsPage {

    public id: string = 'RIGS_Heading';
    public label: string = 'Heading Forecast';

    public station: ParameterSchemaStation;
    public warningGroup: WarningGroup;

    public containerOverride: JQuery;

    constructor(public mainSite: MainSite, public ctx: ILiveDataListenerContext) {
    }

    public notifyResize() {
        this.containerOverride.height($('body').height() - 60);
    }

    public show(station: ParameterSchemaStation): boolean {
        return station.Station.Id === "Australia_Prelude";
    }

    public render(container: JQuery, listeners: ILiveDataListener[], station: ParameterSchemaStation, warningGroup: WarningGroup): void {
        this.station = station;
        this.warningGroup = warningGroup;

        this.containerOverride = $('<div style="padding-left: 26px; padding-right: 26px"></div>')
            .appendTo('body');

        this.containerOverride.height($('body').height() - 60);

        $('<iframe style="height: 100%; width: 100%;" src="/public/special/Prelude/HeadingForecast/HeadingForecast.html"  id="rigsFrame"></iframe>')
            .appendTo(this.containerOverride);
    }
}